import React, { FunctionComponent } from "react";

import { IProps } from "./client-authenticated-routes.types";
import "./client-authenticated-routes.scss";

/**
 * Wrapper around client authenticated routes. This is mostly for applying styles.
 * @param props.children Route content.
 * @returns              Container.
 */
const ClientAuthenticatedRoutes: FunctionComponent<IProps> = ({ children }) => {
    return <div className="client-authenticated-routes">{children}</div>;
};

export default ClientAuthenticatedRoutes;
